export default "__VITE_ASSET__DpTFEhjo__"